module.exports = ".modal-footer {\r\n  background-color: white;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/general/modals/pasajeros/pasajeros.component.css
// module id = ./src/app/components/general/modals/pasajeros/pasajeros.component.css
// module chunks = main